import { environment } from 'environment';
import { classes } from 'shared';
import { A } from '../../general/link';
import { useNavContext } from './context';
import { DateTime } from 'luxon';

export function HeaderBanner() {
  const { blueTopArch } = useNavContext();

  return (
    <section
      className={classes(
        'z-50 w-full text-center',
        environment.name !== 'production' ? 'bg-red-500' : blueTopArch ? 'bg-green-500' : 'bg-blue-500',
      )}>
      <BannerContent />
    </section>
  );
}

function BannerContent() {
  const now = DateTime.now();
  // Holiday Season Banner
  if ((now.month === 12 && now.day > 1) || (now.month === 1 && now.day < 5)){
    return (
      <div
        className="p-1 bg-red-500">
        <div className="text-sm text-white hover:text-gray-200 md:text-base max-w-5xl mx-auto">

          ** Beds for Kids will be closed December 19th-January 4th. Our last day for drop offs will be Dec 18th, and the first day we are open for drop offs will be Monday, January 5th between 9-3:30pm. Thank you and Happy Holidays! **
        </div>
        
      </div>
    );
  }

  // Non-Production Banner
  if (environment.name !== 'production')
    return (
      <A href="/testing" className="text-sm text-white hover:text-gray-200 md:text-base">
        THIS IS NOT THE LIVE BEDSFORKIDS.ORG!!
      </A>
    );

  return (
    <A href="/donate" className="p-1 text-sm text-gray-200 hover:text-gray-300 md:text-base">
      <span className="hidden xs:inline">Donate and change a child & their family's life today! »</span>
      <span className="inline xs:hidden">Donate and change a child's life today! »</span>
    </A>
  );
}
